'use strict';

var angular = require('angular');

var resolvers = {
  performanceReview: require('../../app/performance-review/resolve'),
  salary: require('../../app/salary/resolve'),
  admin: require('../../app/admin/resolve')
};

function AppConfig($routeProvider, $httpProvider, $translateProvider, $datepickerProvider, $timepickerProvider, $navigationProvider, $roleProvider, $locationProvider) {
  var meResolver = {
    me: function(meService) {
      return meService.retrieve();
    }
  };

  // Set meService on all routes
  var extendedRouteProvider = angular.extend({}, $routeProvider, {
    when: function(path, route) {
      // @todo: this needs a better solution
      if (!(/\/login|\/acceptinvite|\/setpassword|\/forgotpassword/.test(path))) {
        route.resolve = angular.extend((route.resolve) ? route.resolve : {}, meResolver);
      }

      $routeProvider.when(path, route);
      return this;
    }
  });

  extendedRouteProvider
    .when('/admin/', {
      template: '<admin me="$resolve.me.data"></admin>'
    })
    .when('/admin/users/', {
      template: '<admin-users me="$resolve.me.data"></admin-users>'
    })
    .when('/admin/users/create', {
      template: '<admin-users-create me="$resolve.me.data"></admin-users-create>'
    })
    .when('/admin/users/import', {
      template: '<manager-import me="$resolve.me.data"></manager-import>'
    })
    .when('/admin/users/contacts', {
      template: '<contact-import me="$resolve.me.data"></contact-import>'
    })
    .when('/admin/users/change-manager', {
      template: '<change-manager me="$resolve.me.data"></change-manager>'
    })
    .when('/admin/users/:user/update', {
      template: '<admin-users-update me="$resolve.me.data" id="$resolve.user"></admin-users-update>',
      resolve: resolvers.admin.user
    })
    .when('/login', {
      template: '<auth-login></auth-login>'
    })
    .when('/logout', {
      template: '<auth-logout></auth-logout>'
    })
    .when('/landing', {
      template: '<landing me="$resolve.me.data"></landing>'
    })

    .when('/performance-review/', {
      template: '<performance-review-round data="$resolve.rounds.data"></performance-review-round>',
      resolve: resolvers.performanceReview.rounds
    })
    .when('/performance-review/:round/invite', {
      template: '<performance-review-invite basis="$resolve.basis.data" data="$resolve.invites.data" me="$resolve.me.data" round="$resolve.round"></performance-review-invite>',
      resolve: angular.extend(resolvers.performanceReview.invites, resolvers.performanceReview.basis)
    })
    .when('/performance-review/:round/invite/import', {
      template: '<performance-review-invite-import round="$resolve.round"></performance-review-invite-import>',
      resolve: resolvers.performanceReview.round
    })
    .when('/performance-review/:round/basis', {
      template: '<performance-review-basis data="$resolve.basis.data" round="$resolve.round"></performance-review-basis>',
      resolve: resolvers.performanceReview.basis
    })
    .when('/performance-review/:round/distribution', {
      template: '<performance-review-distribution round="$resolve.round" data="$resolve.distribution.data"></performance-review-distribution>',
      resolve: resolvers.performanceReview.distribution
    })
    .when('/performance-review/questionnaire/:token/intro', {
      template: '<performance-review-intro data="$resolve.intro.data"></performance-review-intro>',
      resolve: resolvers.performanceReview.intro
    })
    .when('/performance-review/questionnaire/:token/:step', {
      template: '<performance-review-questionnaire token="$resolve.token" data="$resolve.questionnaire.data" step="$resolve.step" me="$resolve.me.data"></performance-review-questionnaire>',
      resolve: resolvers.performanceReview.questionnaire
    })
    .when('/performance-review/questionnaire/:token', {
      template: '<performance-review-summary data="$resolve.summary.data" me="$resolve.me.data"></performance-review-summary>',
      resolve: resolvers.performanceReview.summary
    })
    .when('/performance-review/agreement/questionnaire/:token/:step', {
      template: '<performance-review-agreement-questionnaire token="$resolve.token" data="$resolve.questionnaire.data" step="$resolve.step" me="$resolve.me.data"></performance-review-agreement-questionnaire>',
      resolve: resolvers.performanceReview.agreement.questionnaire
    })
    .when('/performance-review/agreement/questionnaire/:token', {
      template: '<performance-review-agreement-summary data="$resolve.summary.data" me="$resolve.me.data"></performance-review-agreement-summary>',
      resolve: resolvers.performanceReview.agreement.summary
    })
    .when('/performance-review/overview', {
      template: '<performance-review-overview invites="$resolve.invites.data" me="$resolve.me.data"></performance-review-overview>',
      resolve: resolvers.performanceReview.overview
    })

    .when('/salary/', {
      template: '<salary-round data="$resolve.rounds.data"></salary-round>',
      resolve: resolvers.salary.rounds })
    .when('/salary/:round/invite', {
      template: '<salary-invite data="$resolve.invites.data" me="$resolve.me.data" round="$resolve.round"></salary-invite>',
      resolve: resolvers.salary.invites })
    .when('/salary/:round/invite/import', {
      template: '<salary-invite-import round="$resolve.round"></salary-invite-import>',
      resolve: resolvers.salary.round
    })
    .when('/salary/:round/basis', {
      template: '<salary-basis data="$resolve.basis.data" round="$resolve.round"></salary-basis>',
      resolve: resolvers.salary.basis
    })
    .when('/salary/:round/distribution', {
      template: '<salary-distribution round="$resolve.round" data="$resolve.distribution.data"></salary-distribution>',
      resolve: resolvers.salary.distribution
    })
    .when('/salary/questionnaire/:token/intro', {
      template: '<salary-intro data="$resolve.intro.data" me="$resolve.me.data"></salary-intro>', resolve: resolvers.salary.intro
    })
    .when('/salary/questionnaire/:token/:step', {
      template: '<salary-questionnaire token="$resolve.token" data="$resolve.questionnaire.data" step="$resolve.step" me="$resolve.me.data"></salary-questionnaire>',
      resolve: resolvers.salary.questionnaire })
    .when('/salary/questionnaire/:token', {
      template: '<salary-summary data="$resolve.summary.data" me="$resolve.me.data"></salary-summary>',
      resolve: resolvers.salary.summary
    })
    .when('/salary/overview', {
      template: '<salary-overview invites="$resolve.invites.data" me="$resolve.me.data"></salary-overview>',
      resolve: resolvers.salary.overview
    })

    .when('/acceptinvite', {
      template: '<auth-accept invite="true"></auth-accept>'
    })
    .when('/setpassword', {
      template: '<auth-accept invite="false"></auth-accept>'
    })
    .when('/forgotpassword', {
      template: '<forgot-password></forgot-password>'
    })
    .otherwise({
      redirectTo: '/landing'
    });

  $httpProvider.interceptors.push('sessionResponseInterceptor');
  $httpProvider.defaults.xsrfCookieName = 'csrftoken';
  $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

  // TODO: Investigate *why* 'sanitize' does not work. Swedish characters are mangled.
  $translateProvider.useSanitizeValueStrategy(null);
  $translateProvider.useLoader('translationLoader');
  $translateProvider.preferredLanguage('en');

  $roleProvider.use({
    admin:  'Cenceo Administrator',
    manager:'Cenceo Manager',
    user:   'Cenceo Coworker'
  });

  $navigationProvider
    .when('performance-review/', {
      text: 'cenceo.navigation.performance_review',
      icon: 'fa fa-comment',
      role: 'manager',
      override_path:'manager/assessment/round-management/',
      enable: function(user) { return user.customer.performance_reviews; }
    })
    .when('salary/', {
      text: 'cenceo.navigation.salary',
      icon: 'fa fa-briefcase',
      role: 'manager',
      override_path:'manager/performance-assessment/round-management/',
      enable: function(user) { return user.customer.salary_negotiations; }
    })
    .when('admin/users/', {
      text: 'cenceo.navigation.administrator',
      icon: 'fa-solid fa-screwdriver-wrench',
      role: 'admin'
    });

  angular.extend($datepickerProvider.defaults, { dateFormat: 'yyyy-MM-dd', startWeek: 1, dateType: 'iso' });
  angular.extend($timepickerProvider.defaults, { timeFormat: 'HH:mm', timeType: 'iso' });

  $locationProvider.hashPrefix('');
}

module.exports = AppConfig;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/config.js
 ** module id = 318
 ** module chunks = 0
 **/